import {AxiosRequestConfig} from 'axios';

import request from '../../axios';

const getInputLists = async (props: IInputListProps) => {
  const {data}: {data: IInputLists[]} = await request.get(
    `api/v2/store/input-list`,
    {
      params: props,
    } as AxiosRequestConfig,
  );
  return data;
};

export default getInputLists;
